import { useAppSelector } from '../app/hooks';
import {
  selectAllCaseOverviewRecords,
  selectCaseOverviewLoadingStatus,
  selectCaseOverviewError,
} from '../features/analysis/logic/caseOverviewDataSlice';

import { CaseOverviewRecord } from '../lib/interfaces/types';



export interface UseCaseOverviewReturn {
  records: CaseOverviewRecord[];
  isLoading: boolean;
  error: string | null;
}


export const useCaseOverview = (): UseCaseOverviewReturn => {
  const records = useAppSelector(selectAllCaseOverviewRecords);
  const overviewStatus = useAppSelector(selectCaseOverviewLoadingStatus);
  const error = useAppSelector(selectCaseOverviewError);

  const isLoading = overviewStatus === 'pending';

  return { records, isLoading, error };
};